// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"32353ec4","785":"5d8edb81"}[chunkId] + ".chunk.css";
};